export const ANTI_FRAUD = {
	DEVICE_BLACK_BOX: "EREDAV",
	PLATFORM: "WEB",
	APP_VERSION: "1.0",
	TRANSACTION_MARKET: "VN",
	USER_MARKET: "VN",
	USER_COUNTRY_CODE: "VN",
	CURRENCY_CODE: "VND",
}



// WEBPACK FOOTER //
// ./src/constants/antiFraud.js